exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ table-ui .lora-item-table {\n  padding-top: 0; }\n\n.paddingBottom {\n  margin-bottom: 15px !important; }\n\n.padding15 {\n  padding-top: 15px; }\n\n.nav-item {\n  line-height: 1.3;\n  color: rgba(0, 126, 202, 0.4) !important;\n  cursor: pointer; }\n\n.active {\n  border-radius: 4px;\n  font-weight: 700;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);\n  background-color: #007eca;\n  color: white !important; }\n\n.nav-link {\n  color: inherit !important; }\n\n.info-cell {\n  padding: 1px 15px; }\n\n.info-cell-placehokder {\n  color: lightgrey; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/pages/devices-services/devices-services.component.sass
// module id = ../../../../../src/app/pages/devices-services/devices-services.component.sass
// module chunks = main